import LeaderboardTable from "@/src/components/leaderboard/leaderboard-table";
import { RightPanel } from "@/src/components/posts/right-panel/right-panel";
import { useResponsiveGap } from "@/src/hooks/use-responsive-gap";
import { useTheme } from "@/src/styles/theme-provider";
import { useRouter } from "expo-router";
import { useState } from "react";
import { ScrollView, View } from "react-native";

const LeaderboardScreen = () => {
  const router = useRouter();
  const { varStyle } = useTheme();
  const gap = useResponsiveGap();
  const [selectedTag, setSelectedTag] = useState<string | null>(null);

  return (
    <View
      style={varStyle}
      className={`flex-1 flex-row w-full bg-obsidian ${gap}`}
    >
      <ScrollView
        className="w-[100%] md:w-[68%]"
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ flexGrow: 1 }}
      >
        <LeaderboardTable onBack={() => router.back()} />
      </ScrollView>

      <RightPanel
        selectedTag={selectedTag}
        onTagSelect={setSelectedTag}
        onLeaderboardSeeAll={() => router.push("/leaderboard")}
      />
    </View>
  );
};

export default LeaderboardScreen;
